import { BusinesstripApplication } from '../../../model/businesstripapplication';
import { Component, Input, OnInit } from '@angular/core';
import { HisBaseGlobalsService } from 'hisng';
import {
    ENGLISH_DATE_TIME_PIPE_FORMAT,
    GERMAN_DATE_TIME_PIPE_FORMAT
} from 'app/rm/erp/common/model/constants';

@Component( {
    selector: 'erp-businesstripapplication-overview-traveldata',
    templateUrl: './businesstripapplication-overview-traveldata.component.html'
} )
export class BusinesstripApplicationOverviewTraveldataComponent implements OnInit {

    @Input() businesstripApplication?: BusinesstripApplication;
    readonly dateTimeFormat: string;

    constructor(
        private readonly hisBaseGlobalsService: HisBaseGlobalsService,
    ) {
        this.dateTimeFormat = this.hisBaseGlobalsService.getLanguage() === 'de'
            ? GERMAN_DATE_TIME_PIPE_FORMAT : ENGLISH_DATE_TIME_PIPE_FORMAT;
    }

    ngOnInit(): void {
    }
}
